import { getAllRoles } from "pages/Roles/roles.service";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import { statusList } from "utilities/utility.service";
import { ErrorToastConfig } from "utils/ToastConstants";
import { SuccessToastConfig } from "utils/ToastConstants";
import { addUser, getUser, updateUser } from "../users.service";

const initialVales = {
    id: "",
    firstName: "",
    middleName: "",
    lastName: "",
    password: "",
    email: "",
    dob: "",
    role_id: "",
    pancard: "",
    aadhar: "",
    status: "",
};

const AddUser = () => {
    const { id } = useParams();
    const [values, setValues] = useState(initialVales);
    const [roles, setRoles] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const toast = useRef();
    const history = useHistory();

    const showSuccess = (message) => {
        toast.current.show(SuccessToastConfig(message));
    };
    const showError = (message) => {
        toast.current.show(ErrorToastConfig(message ? message : "Error"));
    };

    useEffect(() => {
        const fetchUser = async () => {
            setIsLoading(true);
            const record = await getUser(id);
            setValues(record);
            setIsLoading(false);
        };
        if (id) {
            fetchUser();
        }

        const fetchRoles = async () => {
            const roles = await getAllRoles();
            setRoles(roles);
        };
        fetchRoles();
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (id) {
            const updatedRecord = await updateUser(id, values);
            setValues(updatedRecord);
            if (updatedRecord.status === false) {
                showError(updatedRecord?.message);
            } else {
                showSuccess("Record updated succssfully");
            }
        } else {
            const addedRecord = await addUser(values);
            if (addedRecord.status === false) {
                showError(addedRecord?.message);
            } else {
                showSuccess("Record added succssfully");
            }
            history.push("/users");
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value,
        });
    };
    const statuses = statusList();
    const { firstName, middleName, lastName, role_id, status, email } = values;
    return (
        <Fragment>
            {isLoading && (
                <div className="spinner inner-spinner">
                    <ProgressSpinner />
                </div>
            )}
            <Toast ref={toast} className="ToastMessage" />
            <div className="mb-4">
                <Link to="/users">
                    <Button label="Back" className="p-button-sm p-button-success" />
                </Link>
            </div>
            <form method="POST" onSubmit={handleSubmit} autoComplete="Off">
                <div className="grid">
                    <div className="col-12 md:col-6">
                        <div className="card p-fluid">
                            <h5>{id ? "Edit User" : "Add User"}</h5>
                            <div className="field">
                                <label htmlFor="firstName">First Name*</label>
                                <InputText id="firstName" name="firstName" type="text" required={true} onChange={(e) => handleInputChange(e)} value={firstName} placeholder="Firstname" />
                            </div>
                            <div className="field">
                                <label htmlFor="middleName">Middle Name*</label>
                                <InputText id="middleName" name="middleName" type="text" required={true} onChange={(e) => handleInputChange(e)} value={middleName} placeholder="Middlename" />
                            </div>
                            <div className="field">
                                <label htmlFor="lastName">Last Name*</label>
                                <InputText id="lastName" name="lastName" type="text" required={true} onChange={(e) => handleInputChange(e)} value={lastName} placeholder="Last Name" />
                            </div>
                            <div className="field">
                                <label htmlFor="email">Email*</label>
                                <InputText id="email" name="email" type="email" required={true} onChange={(e) => handleInputChange(e)} value={email} placeholder="Email" />
                            </div>
                            <div className="field">
                                <label htmlFor="password">Password</label>
                                <InputText type="password" name="password" id="password" required={id ? false : true} onChange={(e) => handleInputChange(e)} placeholder="Password" />
                            </div>
                            <div className="field">
                                <label htmlFor="role">Role*</label>
                                <Dropdown id="state" name="role_id" value={values?.role_id} options={roles} optionLabel="name" optionValue="id" placeholder="Select Role" required={true} onChange={(e) => handleInputChange(e)} value={role_id}></Dropdown>
                            </div>
                            <div className="field">
                                <label htmlFor="role">Status*</label>
                                <Dropdown id="status" name="status" value={values?.status} options={statuses} optionLabel="status" optionValue="status" placeholder="Select Status" required={true} onChange={(e) => handleInputChange(e)} value={status}></Dropdown>
                            </div>
                            <div>
                                <Button label="Save" type="submit" />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </Fragment>
    );
};

export default AddUser;
